var _rect, _path, _rect2, _rect3, _circle, _circle2, _circle3, _path2, _rect4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.687 146.47H223C236.437 153.385 244.964 166.196 247.548 171.738L257.276 199H273.995L283.723 171.738C287.69 163.494 297.935 152.898 305.687 146.47Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 56,
    width: 82.6871,
    height: 97.2789,
    rx: 8,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 91.02,
    width: 82.6871,
    height: 26.2653,
    rx: 8,
    fill: "#1C1B1F",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263.501,
    cy: 369.499,
    r: 95.501,
    fill: "#1C1B1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.501,
    cy: 369.499,
    r: 63.3322,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 222.285,
    cy: 366.483,
    r: 22.1158,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.513 285.01C232.43 260.976 252.777 242.222 262.336 235.849C293.471 244.589 300.8 272.265 300.573 285.01C303.304 321.608 274.854 326.661 260.288 324.613C228.606 320.789 225.237 296.618 227.513 285.01Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_10648",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 214,
    width: 127,
    height: 127
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 214,
    width: 127,
    height: 127,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_10648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.5 330.416C252.418 330.416 242.341 326.271 234.272 317.981C226.202 309.69 222.167 299.372 222.167 287.024C222.167 281.556 223.402 276.088 225.871 270.62C228.341 265.152 231.427 259.905 235.132 254.877C238.836 249.85 242.849 245.132 247.17 240.722C251.492 236.313 255.504 232.476 259.209 229.213C259.914 228.507 260.73 228 261.656 227.692C262.582 227.383 263.53 227.229 264.5 227.229C265.47 227.229 266.419 227.383 267.345 227.692C268.271 228 269.086 228.507 269.792 229.213C273.496 232.476 277.509 236.313 281.831 240.722C286.152 245.132 290.165 249.85 293.869 254.877C297.573 259.905 300.66 265.152 303.129 270.62C305.599 276.088 306.834 281.556 306.834 287.024C306.834 299.372 302.799 309.69 294.729 317.981C286.659 326.271 276.583 330.416 264.5 330.416ZM264.5 319.833C273.673 319.833 281.257 316.724 287.254 310.506C293.252 304.288 296.25 296.461 296.25 287.024C296.25 280.586 293.582 273.31 288.247 265.196C282.911 257.082 274.995 248.219 264.5 238.606C254.005 248.219 246.09 257.082 240.754 265.196C235.418 273.31 232.75 280.586 232.75 287.024C232.75 296.461 235.749 304.288 241.746 310.506C247.743 316.724 255.328 319.833 264.5 319.833ZM265.956 314.541C267.014 314.453 267.918 314.034 268.668 313.284C269.417 312.535 269.792 311.631 269.792 310.572C269.792 309.338 269.395 308.345 268.601 307.596C267.808 306.846 266.793 306.515 265.559 306.604C261.943 306.868 258.106 305.876 254.049 303.627C249.992 301.378 247.435 297.299 246.376 291.39C246.2 290.42 245.737 289.626 244.987 289.009C244.238 288.391 243.378 288.083 242.408 288.083C241.173 288.083 240.159 288.546 239.365 289.472C238.571 290.398 238.307 291.478 238.571 292.713C240.07 300.739 243.598 306.471 249.154 309.911C254.711 313.35 260.311 314.894 265.956 314.541Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/안과_결막염.547ab7497122726545a1c19aab616349.svg";
export { ForwardRef as ReactComponent };